import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  label: {
    fontSize: 14,
    color: "#68A300",
  },
  value: {
    fontSize: 14,
    fontWeight: "bold",
  },
  mainTitle: {
    fontSize: 54,
    fontWeight: "bold",
  },
  downloadButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: "150px",
    height: "65px",
    width: "100%",
    marginRight: '10px'
  },
  nextButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: "150px",
    height: "65px",
    width: "100%",
  },
  backButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: "150px",
    height: "65px",
    width: "100%",
  },
  confirmation: {
    alignContent: "center",
    fontWeight: "bold",
    fontSize: 22,
  },
  message: {
    fontSize: 18,
  },
}));

export default useStyles;
